import { render, staticRenderFns } from "./indexList.vue?vue&type=template&id=1bf086c0&scoped=true&"
import script from "./indexList.vue?vue&type=script&lang=js&"
export * from "./indexList.vue?vue&type=script&lang=js&"
import style0 from "./indexList.vue?vue&type=style&index=0&id=1bf086c0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf086c0",
  null
  
)

export default component.exports